import { useEffect } from 'react';
import { flushUmamiQueue } from '../../utils/umami';

/**
 * Injects Umami analytics script only when:
 * - REACT_APP_UMAMI_WEBSITE_ID is set (prod build)
 * - Hostname is leadsme.app (production)
 *
 * No script is loaded in dev/staging, so only production traffic is tracked.
 */
const UmamiAnalytics: React.FC = () => {
  useEffect(() => {
    const websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;

    if (!websiteId || window.location.hostname !== 'leadsme.app') {
      return;
    }

    if (document.querySelector('script[data-website-id]')) {
      return;
    }

    const s = document.createElement('script');
    s.defer = true;
    s.src = 'https://cloud.umami.is/script.js';
    s.setAttribute('data-website-id', websiteId);
    s.setAttribute('data-performance', 'true');
    s.onload = () => flushUmamiQueue();
    document.head.appendChild(s);
  }, []);

  return null;
};

export default UmamiAnalytics;
